import VueI18n from "vue-i18n";
import Vue from "vue";
import messages from "./assets/messages.json";

Vue.use(VueI18n);

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "de",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "de",
  messages: messages,
});
